export const formatDuration = (
  startTime: number | null | undefined,
  endTime: number | null | undefined,
): string => {
  if (!startTime || !endTime) return '00:00'
  const seconds = endTime - startTime

  const h = Math.floor(Number(seconds) / 3600)
  const m = Math.floor((Number(seconds) % 3600) / 60)
  const s = Number(seconds) % 60

  if (h > 0) {
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }
  return `${m}:${s.toString().padStart(2, '0')}`
}
